import { getLogger } from '../../commons/logger';
import type { WebDriver } from '../webdriver';
import type { Cookie as _Cookie } from '@wdio/protocols/build/types';

const logger = getLogger('cookies-utils');
export interface Cookie extends Omit<_Cookie, 'expiry'> {
    hostOnly?: boolean;
    expirationDate?: number;
}

export class CookieUtils {
    constructor(private readonly driver: WebDriver) {}
    async set(cookie: Cookie) {
        let domain = cookie.domain;
        if (!cookie.hostOnly && domain && !domain.startsWith('.')) {
            domain = `.${domain}`;
        }
        try {
            return await this.driver.setCookie(cookie.name, cookie.value, domain, cookie.httpOnly, cookie.secure, cookie.path, cookie.expirationDate);
        } catch (err) {
            logger.error('failed to set cookie', { err });
            throw err;
        }
    }

    async get(cookie: Pick<Cookie, 'name'>) {
        try {
            return await this.driver.getCookie(cookie.name);
        } catch (err) {
            logger.error('failed to get cookie', { err });
            throw err;
        }
    }

    async remove(cookie: Pick<Cookie, 'name'>) {
        try {
            return await this.driver.deleteCookie(cookie.name);
        } catch (err) {
            logger.error('failed to remove cookie', { err });
            throw err;
        }
    }
}
